import * as React from 'react'
import { SxProps } from '../sx'
import clsx from 'clsx'
import style from './index.module.scss'
import { FormControlProps } from '../FormControl'
import { capitalize } from '../../utils'
import { NativeSelectClasses } from './classes'
import { SvgIconProps } from '../SvgIcon'

export interface NativeSelectInputProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  disabled?: boolean
  IconComponent: React.ElementType<Omit<SvgIconProps, 'children'>>
  inputRef?: React.Ref<HTMLSelectElement>
  variant?: FormControlProps['variant']
  selcetSize?: FormControlProps['size']
  error?: boolean
  focused?: boolean
  sx?: SxProps
  classes?: Omit<NativeSelectClasses, 'root'>
}

/**
 * @ignore - internal component.
 */
export const NativeSelectInput = React.forwardRef<
  HTMLSelectElement,
  NativeSelectInputProps
>(function NativeSelectInput(props, ref) {
  const {
    className,
    disabled,
    error,
    focused,
    IconComponent,
    inputRef,
    variant = 'standard',
    selcetSize: size = 'medium',
    classes,
    // @ts-ignore
    Component: _,
    ...other
  } = props

  return (
    <React.Fragment>
      <select
        className={clsx(
          [style.select, classes?.select],
          disabled && [style.disabled, classes?.disabled],
          style[`variant${capitalize(variant)}`],
          classes?.[variant],
          style[`size-${size}`],
          // @ts-ignore
          classes?.[`size${capitalize(size)}`],
          error && [classes?.error],
          className
        )}
        disabled={disabled}
        ref={inputRef || ref}
        {...other}
      />
      {props.multiple ? null : (
        <IconComponent
          className={clsx(
            [style.selectIcon, classes?.icon],
            disabled && style.disabled,
            style[`variant${capitalize(variant)}`],
            focused && [style.open, classes?.iconOpen],
            style[`size-${size}`]
          )}
        />
      )}
    </React.Fragment>
  )
})
